import { Filter, MultiValueFilter, SingleValueFilter } from 'services/Filter';
import { EVENT_STATUS, EVENT_TYPES } from 'store/Events/types';
import { replaceSpecialChars } from 'utils';

export const prepareFilter = (
  filters: Filter[],
  idCommunities: (string | number)[],
  excludeFullEvents = false,
) => {
  const _filters = filters.map((filter) => {
    if (filter.property === 'search') {
      const searchFilter = filter.clone();
      searchFilter.value = replaceSpecialChars(searchFilter.value ?? '');
      return searchFilter;
    }

    return filter;
  });

  if (idCommunities.length > 0) {
    _filters.push(new MultiValueFilter('client', 'in', idCommunities));
  }

  if (excludeFullEvents) {
    _filters.push(new SingleValueFilter('type', 'neq', EVENT_TYPES.EVENT_FULL));
  }

  return [
    ..._filters,
    new SingleValueFilter('status', 'neq', EVENT_STATUS.INACTIVE),
  ];
};
